module.exports = "<div class=\"convert-field button-field\">\n\n    <button type=\"button\" mat-raised-button #input\n      color=\"accent\"\n      [disabled]=\"(locked || disabled || standard == null)\"\n      (click)=\"showInputDialog()\">\n      Convert\n    </button>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/forms/convert-field.component.html
// module id = ./src/app/forms/convert-field.component.html
// module chunks = main